import Chip from "@mui/material/Chip";

export function StatusChip({ orderId }: { orderId?: string }) {
  return orderId ? (
    <Chip
      label="Zamówione"
      size="small"
      sx={{ bgcolor: "rgba(25, 135, 84, 0.1)", color: "#198754", fontWeight: 600, fontSize: "0.75rem" }}
    />
  ) : (
    <Chip
      label="W toku"
      size="small"
      sx={{ bgcolor: "rgba(13, 110, 253, 0.1)", color: "primary.main", fontWeight: 600, fontSize: "0.75rem" }}
    />
  );
}
